import React from 'react';
import { Link } from 'react-router-dom';
import { Palette, Zap, Target, Sparkles, ArrowRight } from 'lucide-react';
import { solutionsData } from '../data/mock';

const iconMap = {
  Palette,
  Zap,
  Target,
  Sparkles,
};

const SolutionSection = () => {
  return (
    <section className="section" id="solution">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-block text-sm font-semibold text-[#FF6B35] uppercase tracking-wider mb-4">
              The Solution
            </span>
            <h2 className="heading-1 mb-6">
              High-Performance Websites Built for{' '}
              <span className="gradient-text">Athletes & Creators</span>
            </h2>
            <p className="body-large mb-8">
              We don't do generic. Every site we build is custom-designed to match your brand, 
              optimized for speed, and engineered to convert your social media traffic into 
              bookings, sales, and wins.
            </p>
            
            <div className="space-y-4">
              {solutionsData.map((solution, index) => {
                const IconComponent = iconMap[solution.icon];
                return (
                  <div 
                    key={solution.id}
                    className="flex items-start gap-4 p-4 rounded-xl hover:bg-[#12121A] border border-transparent hover:border-[#2A2A35] transition-all animate-fade-in-up"
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <div className="feature-icon">
                      <IconComponent size={24} />
                    </div>
                    <div>
                      <h3 className="font-semibold text-white mb-1">
                        {solution.title}
                      </h3>
                      <p className="text-sm text-[#6B6B78]">
                        {solution.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
            
            <Link 
              to="/contact"
              className="btn-primary mt-8"
            >
              Get a Free Quote
              <ArrowRight size={18} />
            </Link>
          </div>
          
          {/* Right Visual */}
          <div className="relative">
            <div className="bg-[#12121A] rounded-2xl p-8 border border-[#2A2A35]">
              {/* Browser mockup */}
              <div className="rounded-xl overflow-hidden border border-[#2A2A35]">
                {/* Browser bar */}
                <div className="bg-[#1A1A24] px-4 py-3 flex items-center gap-2">
                  <div className="flex gap-1.5">
                    <div className="w-3 h-3 rounded-full bg-red-500/60" />
                    <div className="w-3 h-3 rounded-full bg-yellow-500/60" />
                    <div className="w-3 h-3 rounded-full bg-green-500/60" />
                  </div>
                  <div className="flex-1 mx-8">
                    <div className="bg-[#0A0A0F] rounded-lg px-4 py-1.5 text-xs text-[#6B6B78] text-center border border-[#2A2A35]">
                      yourbrand.com
                    </div>
                  </div>
                </div>
                
                {/* Website content */}
                <div className="bg-[#0A0A0F] p-6 min-h-[300px]">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#FF6B35] to-[#FF8555]" />
                    <div>
                      <div className="h-4 w-32 bg-[#2A2A35] rounded mb-2" />
                      <div className="h-3 w-24 bg-[#1A1A24] rounded" />
                    </div>
                  </div>
                  
                  <div className="space-y-3">
                    <div className="h-12 bg-gradient-to-r from-[#FF6B35] to-[#FF8555] rounded-lg flex items-center justify-center">
                      <span className="font-semibold text-black">Book a Session</span>
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                      <div className="h-12 bg-[#1A1A24] border border-[#2A2A35] rounded-lg flex items-center justify-center">
                        <span className="text-sm text-[#B8B8C0]">Programs</span>
                      </div>
                      <div className="h-12 bg-[#1A1A24] border border-[#2A2A35] rounded-lg flex items-center justify-center">
                        <span className="text-sm text-[#B8B8C0]">Shop</span>
                      </div>
                    </div>
                    <div className="h-12 bg-[#1A1A24] border border-[#2A2A35] rounded-lg flex items-center justify-center">
                      <span className="text-sm text-[#B8B8C0]">Watch My Journey</span>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Floating stats */}
              <div className="absolute -right-4 top-1/4 bg-[#12121A] border border-[#FF6B35]/30 rounded-xl p-4 shadow-lg glow-orange">
                <div className="text-2xl font-bold text-white">+127%</div>
                <div className="text-xs text-[#6B6B78]">Conversion Rate</div>
              </div>
              
              <div className="absolute -left-4 bottom-1/4 bg-[#12121A] border border-[#00D4FF]/30 rounded-xl p-4 shadow-lg glow-cyan">
                <div className="text-2xl font-bold text-[#00D4FF]">0.8s</div>
                <div className="text-xs text-[#6B6B78]">Load Time</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
